import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {hex2rgba, spacing} from '@yandex-delivery/blocks/theme/theme'

export const headerClasses = {
  header: css`
    position: fixed;
    inset-inline-start: 0;
    z-index: 100;
    inline-size: 100%;
    touch-action: pan-y;
  `,
  firstLine: css`
    inline-size: 100%;
    color: ${cssTheme.default.day.everWhite};
    background-color: ${cssTheme.colors.deliveryGrey[450]};
    display: flex;
    justify-content: center;
    padding-inline: ${spacing(5)};
    padding-block: ${spacing(1.25)};
    box-sizing: border-box;
    block-size: ${spacing(5)};
  `,
  secondLine: css`
    margin-block-start: ${spacing(-0.125)};
    inline-size: 100%;
    background: ${hex2rgba(cssTheme.default.day.everBlack.hex, 0.7)};
    border-radius: ${spacing(0, 0, 1.875, 1.875)};
    -webkit-backdrop-filter: blur(${spacing(3.125)});
    min-block-size: ${spacing(10)};
    block-size: max-content;
    backdrop-filter: blur(${spacing(3.125)});
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  `,

  actionsPanel: css`
    block-size: ${spacing(10)};
    inline-size: 100%;
    padding-inline: ${spacing(5)};
    padding-block: ${spacing(1.875)};
  `,
  leftSide: css`
    & > * {
      margin-inline-end: ${spacing(3.75)};
    }
  `,
  linksList: css`
    & > *:not(:last-child) {
      margin-inline-end: ${spacing(3.125)};
    }
  `,
  rightSide: css`
    inline-size: auto;
    display: inline-flex;

    & > *:not(:last-child) {
      padding-inline-end: ${spacing(7.5)};
    }
  `,
  buttonList: css`
    & > *:not(:last-child) {
      margin-inline-end: ${spacing(1.25)};
    }
  `,
  logo: css`
    block-size: ${spacing(4)};
    inline-size: ${spacing(20.375)};
  `,
  avatar: css`
    inline-size: ${spacing(6.25)};
    block-size: ${spacing(6.25)};
  `,
  username: css`
    color: ${cssTheme.default.day.everWhite};
  `,
  linksContent: css`
    padding: ${spacing(2.5)};
  `,
}
